__turbopack_context__.v({
  "api-mock-warning": "Layout-module-scss-module__oBWOzG__api-mock-warning",
  "app-picker-wrapper": "Layout-module-scss-module__oBWOzG__app-picker-wrapper",
  "close-toast-button-container": "Layout-module-scss-module__oBWOzG__close-toast-button-container",
  "close-toast-button-icon": "Layout-module-scss-module__oBWOzG__close-toast-button-icon",
  "content": "Layout-module-scss-module__oBWOzG__content",
  "footer": "Layout-module-scss-module__oBWOzG__footer",
  "gray-bg": "Layout-module-scss-module__oBWOzG__gray-bg",
  "header-inner": "Layout-module-scss-module__oBWOzG__header-inner",
  "header-outer": "Layout-module-scss-module__oBWOzG__header-outer",
  "is-dark": "Layout-module-scss-module__oBWOzG__is-dark",
  "is-grey": "Layout-module-scss-module__oBWOzG__is-grey",
  "is-light": "Layout-module-scss-module__oBWOzG__is-light",
  "links": "Layout-module-scss-module__oBWOzG__links",
  "logo": "Layout-module-scss-module__oBWOzG__logo",
  "logo-wrapper": "Layout-module-scss-module__oBWOzG__logo-wrapper",
  "logotype": "Layout-module-scss-module__oBWOzG__logotype",
  "meta": "Layout-module-scss-module__oBWOzG__meta",
  "mozilla-logo": "Layout-module-scss-module__oBWOzG__mozilla-logo",
  "nav-wrapper": "Layout-module-scss-module__oBWOzG__nav-wrapper",
  "non-header-wrapper": "Layout-module-scss-module__oBWOzG__non-header-wrapper",
  "patch3701": "Layout-module-scss-module__oBWOzG__patch3701",
  "plain-page": "Layout-module-scss-module__oBWOzG__plain-page",
  "stock-photo-disclaimer": "Layout-module-scss-module__oBWOzG__stock-photo-disclaimer",
  "toast": "Layout-module-scss-module__oBWOzG__toast",
  "toast-container": "Layout-module-scss-module__oBWOzG__toast-container",
  "user-menu-wrapper": "Layout-module-scss-module__oBWOzG__user-menu-wrapper",
  "wrapper": "Layout-module-scss-module__oBWOzG__wrapper",
});
